module.exports = __webpack_public_path__ + "static/ead-04-a559c6012ee774897e07725af303b3b3.png";